module.exports = __webpack_public_path__ + "static/media/img_01.57f9ca43.png";